import React, { useState } from "react";
import localization from "assets/localization/localization";
import DatePicker from "components/sales/datePicker/datePicker";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "../Input/dropDownInput/dropDownInput";

const OffroleEmployeesFilter = ({
  applyFilter,
  getDropdownDatas,
  activeInactive,
}) => {
  const filterInputs = {
    filter_status: null,
    vendor_name: "",
    // role_id: null,
    employee_type: null,
    requested_from_date: "",
    requested_to_date: "",
    approved_from_date: "",
    approved_to_date: "",
    user_name: "",
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  console.log("getDropdownDatas", getDropdownDatas);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      {activeInactive ? (
        <>
          <DropDownInput
            data={getDropdownDatas?.response?.data?.employee_types}
            label={localization.employeeType}
            getIdValue={(val) => {
              setFilterFieldsData({
                ...filterFieldsData,
                employee_type: val?.id,
              });
            }}
            getValueById={
              window.localStorage?.getoffRoleEmployeesData &&
              window.localStorage?.getoffRoleEmployeesData
                ? JSON.parse(window.localStorage?.getoffRoleEmployeesData)[
                    "employee_type"
                  ]
                : ""
            }
          />
          <DropDownInput
            label={localization.status}
            data={[
              { id: 1, name: "Active" },
              { id: 2, name: "In-active" },
            ]}
            getIdValue={(val) => {
              setFilterFieldsData({
                ...filterFieldsData,
                filter_status: val?.id,
              });
            }}
            getValueById={
              window.localStorage?.getoffRoleEmployeesData &&
              window.localStorage?.getoffRoleEmployeesData
                ? JSON.parse(window.localStorage?.getoffRoleEmployeesData)[
                    "filter_status"
                  ]
                : ""
            }
          />
          <DatePicker
            label={localization.approvedFromDate}
            value={
              window.localStorage?.getoffRoleEmployeesData &&
              window.localStorage?.getoffRoleEmployeesData
                ? JSON.parse(window.localStorage?.getoffRoleEmployeesData)[
                    "approved_from_date"
                  ]
                : ""
            }
            handleChange={(val) => {
              setFilterFieldsData({
                ...filterFieldsData,
                approved_from_date: val,
              });
            }}
            required={false}
          />
          <DatePicker
            label={localization.approvedToDate}
            value={
              window.localStorage?.getoffRoleEmployeesData &&
              window.localStorage?.getoffRoleEmployeesData
                ? JSON.parse(window.localStorage?.getoffRoleEmployeesData)[
                    "approved_to_date"
                  ]
                : ""
            }
            handleChange={(val) => {
              setFilterFieldsData({
                ...filterFieldsData,
                approved_to_date: val,
              });
            }}
            required={false}
          />

          <ConstantInput
            label={localization.userName}
            type="text"
            handleChange={(value) => {
              setFilterFieldsData({ ...filterFieldsData, user_name: value });
            }}
          />
        </>
      ) : (
        <DropDownInput
          label={localization.status}
          data={[
            { id: "5", name: "Pending" },
            { id: "2", name: "Rejected" },
          ]}
          getIdValue={(val) => {
            setFilterFieldsData({
              ...filterFieldsData,
              filter_status: val?.id,
            });
          }}
          getValueById={
            window.localStorage?.getoffRoleEmployeesData &&
            window.localStorage?.getoffRoleEmployeesData
              ? JSON.parse(window.localStorage?.getoffRoleEmployeesData)[
                  "filter_status"
                ]
              : ""
          }
        />
      )}
      <DatePicker
        label={localization.requestFromDate}
        value={
          window.localStorage?.getoffRoleEmployeesData &&
          window.localStorage?.getoffRoleEmployeesData
            ? JSON.parse(window.localStorage?.getoffRoleEmployeesData)[
                "requested_from_date"
              ]
            : ""
        }
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            requested_from_date: val,
          });
        }}
        required={false}
      />
      <DatePicker
        label={localization.requestToDate}
        value={
          window.localStorage?.getoffRoleEmployeesData &&
          window.localStorage?.getoffRoleEmployeesData
            ? JSON.parse(window.localStorage?.getoffRoleEmployeesData)[
                "requested_to_date"
              ]
            : ""
        }
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            requested_to_date: val,
          });
        }}
        required={false}
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default OffroleEmployeesFilter;
